import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useGrowthBookReady } from '@web-app/hooks/useGrowthBookReady';

export const useSettingsPageAccess = (): boolean => {
  const isGrowthBookReady = useGrowthBookReady();
  const hasAccess = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.SETTINGS_PAGE_ACCESS,
  );

  return isGrowthBookReady && hasAccess;
};
